import { Field, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class ArcTeamUserStatusLogDto {
  @Field({ nullable: true })
  date!: Date

  @Field(t => Int)
  type!: number
}
